import { type IBuyerRegistrationProfileInfoQuery } from 'application/querySchemas/IBuyerRegistrationProfileInfoQuery';
import { type IBuyerUserTokenRepository } from 'application/repositorySchemas/IBuyerUserTokenRepository';
import {
    type IBuyerRegistrationProfileInfoClient,
    IGetResponse,
} from 'interfaceAdapter/gatewaySchemas/IBuyerRegistrationProfileInfoClient';
import { inject, injectable } from 'tsyringe';

@injectable()
export class BuyerRegistrationProfileInfoQuery implements IBuyerRegistrationProfileInfoQuery {
    constructor(
        @inject('IBuyerUserTokenRepository')
        public readonly buyerUserToken: IBuyerUserTokenRepository,
        @inject('IBuyerRegistrationProfileInfoClient')
        public readonly buyerRegistrationProfileInfoClient: IBuyerRegistrationProfileInfoClient,
    ) {}

    public async fetch(): Promise<IGetResponse['data']> {
        const { data, message } = await this.buyerRegistrationProfileInfoClient.get({
            token: this.buyerUserToken.get() || undefined,
        });
        if (message) {
            throw new Error(message);
        }
        return data;
    }
}
